// imports montreal_edge_letters_gotham_numbers_font.js
letterAdjust.outline = '#ed1b34';
letterAdjust.x = 5;
letterAdjust.scale = 0.9;

var canadian_flag = true,
	colors = {
		characters: {
			home: [
				"#FFFFFF"
			]
		},
		numbers: {
			home: [
				"#FFFFFF"
			]
		}
	},
	outlines = {
		characters: {
			width: 0
		},
		numbers: {
			width: 0
		}
	},
	special_Character_Adjustments = {
		period: {
			vertical: -5,
			horizontal: -2.5,
			scale_width: 15.5,
			scale_height: 15.5,
		}
	};